import React from "react";
import { useNavigate } from "react-router-dom";
import { Users } from "lucide-react";

const QuickActions = ({ quickActions }) => {
  const navigate = useNavigate();

  return (
    <div className="mb-8">
      <h2 className="text-lg font-semibold mb-4">Quick Actions</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions.map((action, index) => (
          <button
            key={index}
            onClick={() => navigate(action.route)}
            className="flex items-center justify-between p-4 bg-white rounded-lg border hover:shadow-md"
          >
            <div className="flex items-center">
              <div className="p-2 bg-blue-50 rounded-lg">
                <Users size={20} className="text-blue-600" />
              </div>

              <div className="ml-3 text-left">
                <p className="text-sm font-medium">{action.name}</p>
                <p className="text-xs text-gray-500">{action.count} items</p>
              </div>
            </div>

            <span className="text-blue-600">→</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default React.memo(QuickActions);